import { useLocalSearchParams } from 'expo-router';

/**
 * Unavailable section deeplink target for Full Menu chrome.
 * Set when a store-scoped section is missing/empty after store selection.
 */
export const useUnavailableSectionId = (): string | undefined => {
  const { unavailableSectionId } = useLocalSearchParams<{
    unavailableSectionId?: string | string[];
  }>();

  if (!unavailableSectionId) {
    return undefined;
  }

  const raw = Array.isArray(unavailableSectionId) ? unavailableSectionId[0] : unavailableSectionId;
  const id = raw?.trim();
  return id || undefined;
};
